import angular from 'angular';
import wysiwygEditorComponent from './wysiwyg-editor.component';

let wysiwygEditorModule = angular.module('wysiwygEditor', [])
  .component('wysiwygEditor', wysiwygEditorComponent);

export default wysiwygEditorModule;





// WEBPACK FOOTER //
// ./client/common/directives/wysiwyg-editor/wysiwyg-editor.js